import React from "react";

const SuccessPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center">
      <div className="bg-green-500 rounded-full p-4">
        <svg
          className="w-12 h-12 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          ></path>
        </svg>
      </div>
      <h1 className="mt-4 text-2xl font-bold">Authentication complete</h1>
      <p className="mt-2 text-gray-600">You may now close this window</p>
    </div>
  );
};

export default SuccessPage;
